jQuery(document).ready(function ($) {
  /*****************************************************************
    External Link Button Tracking
  ******************************************************************/
  $(".external-link-btn").on("click", function () {
    const pageTitle = document.title.trim();
    const eventLink = $(this).attr("href");
    const pageType = $("body").attr("class").split(" ")[0]; // Get the first class from body

    gtag("event", "external_link_click", {
      event_category: "collab_link_click",
      page_title: pageTitle,
      collab_link: eventLink,
      page_type: pageType,
      value: 1,
    });
  });
  /*****************************************************************
    END – External Link Button Tracking
  ******************************************************************/
});
